module.exports = __webpack_public_path__ + "static/media/Logo Shira Media.f1c585ab.png";